import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { LOADING_SPINNER_BASE_CLASSNAME } from './Constants';
import { createLoadingSpinner } from './LoadingSpinner';
createComponents(".".concat(LOADING_SPINNER_BASE_CLASSNAME), createLoadingSpinner, NO_PATTERN_BUSINESS_LOGIC);
